import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'highlight.js/styles/monokai-sublime.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
// 云服务器公共变量-后端请求地址
Vue.prototype.$baseUrl = 'https://ailibrary.fun:8081';
Vue.prototype.$webSocketUrl = 'wss://ailibrary.fun:8081/imserver/';
// 本地服务公共变量-后端请求地址
// Vue.prototype.$baseUrl = 'http://192.168.124.18:8081';
// Vue.prototype.$webSocketUrl = 'ws://localhost:8081/imserver/';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
